export type TimeOfDayPeriod = 'morning' | 'day' | 'night';

export const TIME_OF_DAY_THEME_COLOR: Record<TimeOfDayPeriod, string> = {
  morning: '#facfcb',
  day: '#fde08b',
  night: '#f8d4c3',
};

/**
 * Boundaries follow the Workday brand guide's own three-way split
 * (https://brand.workday.com/document/89#/-/gradients): Morning, Day, Night.
 * Hours are in the visitor's local time.
 */
export function resolveTimeOfDayPeriod(
  date: Date = new Date(),
): TimeOfDayPeriod {
  const hour = date.getHours();
  if (hour >= 5 && hour < 12) return 'morning';
  if (hour >= 12 && hour < 18) return 'day';
  return 'night';
}
